import { IExpenseCategory } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	name: string
	slug?: string
	fields: {
		name: string
		type: string
		position: number
	}[]
	note?: string
}

export async function expenseCategoryAddApi(payload: RequestDataShape, token: string) {
	const endpoint = "/expense/category/add/v1"
	const requester = new ApiRequester<RequestDataShape, IExpenseCategory>(endpoint)
	return await requester.sendRequest(payload, token)
}
